import { withStyles } from '../../tools/withStyles';
import { withAnimation } from '../../tools/withAnimation';
import { withSounds } from '../../tools/withSounds';
import { Component } from './Menu';
import { styles } from './Menu.styles';

const Menu = withAnimation()(withStyles(styles)(withSounds()(Component)));

export { Menu };

// Commit trace: 2025-08-01T08:09:31 - perf: speed up execution in index.js

// Commit trace: 2026-02-15T11:14:43 - docs: clarify parameter types in index.js
